import { InjectionToken } from '@angular/core';
import { IConfig } from './config.service';

export const APP_CONFIG = new InjectionToken<IConfig>('app-config');
export const CONFIG_URL = './assets/config/config.json';
